import { api } from ".";

export interface Role {
    Id: number;
    ApplicationId: number;
    Name: string;
    Description: string;
    Weight: number;
    IsActive: boolean;
    PrivilegesCount: number;
}

export interface RolePrivileges {
  RoleId: number;
  PrivilegeIds: number[];
}

const rolesUrlV1 = "/v1/roles";
const applicationsUrlV1 = "/v1/Applications";
const applicationCustomerUserRolesUrlV1 = "/v1/ApplicationCustomerUserRoles";
const rolePrivilegesUrlV1 = "/v1/RolePrivileges";

export const getRolesByApplicationId = async (appId: number) => {
  const response = await api.get<Role[]>(`${applicationsUrlV1}/${appId}/roles`);
  return response?.data;
};

export const getRolesByApplicationIdAndCustomerIdAndUserId = async (appId: number, customerId: number, userId: number) => {
  const response = await api.get<Role[]>(
    `${applicationCustomerUserRolesUrlV1}/${appId}/customers/${customerId}/users/${userId}/roles`);
  return response?.data;
};

export const addRole = async (role: Role) => {
  const response = await api.post(`${rolesUrlV1}`, role);
  return response?.data;
}

export const getRole = async (roleId: number) => {
  const response = await api.get<Role>(`${rolesUrlV1}/${roleId}`);
  return response?.data;
}

export const deleteRole = async (roleId: number) => {
  const response = await api.delete(`${rolesUrlV1}/${roleId}`);
  return response?.status === 204;
}

export const addRolePrivileges = async (rolePrivileges: RolePrivileges) => {
  const response = await api.post(`${rolePrivilegesUrlV1}`, {...rolePrivileges, IsActive: true});
  return response?.data;
}

export const removeRolePrivileges = async (rolePrivileges: RolePrivileges) => {
  const response = await api.post(`${rolePrivilegesUrlV1}`, {...rolePrivileges, IsActive: false});
  return response?.data;
}